import FavouriteButtonController from './favourite-button-controller'

export default FavouriteButtonController
